import { makeVar } from "@apollo/client";
import { LanguageCache } from "types";
import { getLanguageData, storeLanguage } from "utils/language";

const languageData = getLanguageData();
export const languageDataVar = makeVar<LanguageCache>({
  studyLanguageId: languageData.studyLanguageId || "1",
});

export const setLanguageDataVar = (data: LanguageCache) => {
  storeLanguage(data);
  return languageDataVar({
    studyLanguageId: data.studyLanguageId,
  });
};
